import axios from 'axios';
import { authConstants } from '../actions/constants';
import { api } from '../HelperFunction';
import store from '../store';

const token = window.localStorage.getItem('token');

const axiosInstance = axios.create({
	baseURL: api,
	headers: {
		Authorization: token ? `Bearer ${token}` : ''
	}
});

axiosInstance.interceptors.request.use((req) => {
	const { auth } = store.getState();

	if (auth.token) {
		req.headers.Authorization = `Bearer ${auth.token}`;
	}
	return req;
});

axiosInstance.interceptors.response.use(
	(res) => {
		return res;
	},
	(error) => {
		// console.log(error.message);
		const status = error.response ? error.response.status : 500;

		if (status === 401 || status === 403) {
			localStorage.removeItem('token');
			localStorage.removeItem('user');
			store.dispatch({ type: authConstants.LOGOUT_SUCCESS });
		} else if (status === 500) {
			localStorage.clear();
			store.dispatch({ type: authConstants.LOGOUT_SUCCESS });
		}
		return Promise.reject(error);
	}
);

export default axiosInstance;
